<template>
  <v-card class="d-flex align-center justify-center" light min-width="25vw" outlined style="z-index: 10!important;">
    <div style="width: 100% !important;">
      <v-card-title class="text-center py-1" style="background-color: #d2d7e1">
        <v-list-item>
          <v-list-item-title><h2>{{ $t('proposeFeature') }}</h2></v-list-item-title>
          <v-spacer/>
          <v-list-item-action>
            <v-icon class="icon" icon @click="closeWindow">fa-times</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-card-title>
      <v-card-text>
        <v-overlay :absolute="true" :value="overlayProgress"><v-progress-circular :size="70" width="5" indeterminate/></v-overlay>
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-form v-model="valid" style="width: 84%" class="mb-5 mt-7">
              <h4 class="text-center mb-5">{{ $t('form.feature.header') }}</h4>
              <v-text-field :label=" $t('form.feature.label')" :placeholder="$t('form.feature.placeholder')" v-model="featureName" :rules="nameRules" outlined/>
              <v-textarea :label="$t('form.featureDescription.label')" :placeholder="$t('form.featureDescription.placeholder')" :rows="3"
                          counter auto-grow  v-model="featureDescription" :rules="descriptionRules" outlined/>
              <v-row class="mt-1" align="center" justify="center">
                <v-btn @click="proposeIt">{{ $t('submission') }} »</v-btn>
              </v-row>
            </v-form>
          </v-row>
        </v-container>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/analytics';

export default {
  name: "ProposeFeature",
  data() {
    return {
      featureName: '',
      featureDescription: '',
      overlayProgress: false,

      // Rules
      valid: false,
      nameRules: [
        n => !!n || 'Feature is required',
        n => (n && n.length <= 50) || 'Max 50 characters',
      ],
      descriptionRules: [
        d => !!d || 'Description is required',
        d => (d && d.length <= 100) || 'Max 100 characters',
      ],
    };
  },
  methods: {
    closeWindow() {
      this.$emit('closeWindow');
    },
    proposeIt() {
      if (this.valid) {
        this.overlayProgress = true;
        let featureData = {
          userId: this.$store.state.user.id,
          name: this.featureName,
          description: this.featureDescription,
        };

        Repository.proposeCustomFeature(featureData).then((response) => {
          if (response.status < 400) {
            alert('Feature was submitted! Thank you for your proposal.');
            this.closeWindow();
          }
        });
      }
    },
  }
}
</script>

<style scoped>

</style>


<i18n>
{
  "en":{
    "proposeFeature": "Propose a Feature",
    "form":{
      "feature":{
        "header": "We listen your experienced voice",
        "label": "Feature",
        "placeholder": "Trade view in calendar"
      },
      "featureDescription":{
        "label": "Feature Description",
        "placeholder": "E.g. see trades in my calendar."
      }
    },
    "submission": "Send Feature"
  },
  "es":{
    "proposeFeature": "Haz una Propuesta",
    "form":{
      "feature":{
        "header": "Escuchamos tu experiencia",
        "label": "Funcionalidad",
        "placeholder": "Vista del trade en el calendario"
      },
      "featureDescription":{
        "label": "Descripción de la funcionalidad",
        "placeholder": "Ejemplo: Ver trades en mi calendario."
      }
    },
    "submission": "Enviar Funcionalidad"
  }
}
</i18n>
